import AuthenticateIntegrationAppView from './view'

export default AuthenticateIntegrationAppView